import React from 'react';
import type BulkEmailType from '@jira/admin-pages__bulk-email-page/src/BulkEmailPage.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyBulkEmail = lazyForPaint<typeof BulkEmailType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-admin-pages-bulk-email", jiraSpaEntry: "jira-admin-pages-bulk-email" */ '@jira/admin-pages__bulk-email-page/src/BulkEmailPage.tsx'
		),
	),
);

const AsyncBulkEmail = (): React.JSX.Element => (
	<LazyPage Page={LazyBulkEmail} pageId="jira-admin-pages-bulk-email" shouldShowSpinner />
);

export default AsyncBulkEmail;
